import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Form, Input} from 'antd'

@inject('store') @observer
class Save extends Component {
  handleChange = (e) => {
    const {name, value} = e.target
    const {algo} = this.props.store
    algo.single.change(name, value)
  }
  handleOk = () => {
    const {algo} = this.props.store
    algo.single.create()
  }
  render() {
    const {data, errors, loading} = this.props.store.algo.single
    const editing = !!data.id
    return(
      <Modal
        title={editing ? 'You can change the name and save this as a new algo' : 'Save your Algo to test it'}
        visible={this.props.visible}
        onOk={this.handleOk}
        onCancel={this.props.close}
        confirmLoading={loading}
      >
        <Form>
          <Form.Item
            label='Name'
            required
            validateStatus={errors.name ? 'error' : null}
            help={errors.name}
          >
            <Input
              name='name'
              value={data.name}
              onChange={this.handleChange}
              size='large'
            />
          </Form.Item>
          <Form.Item
            label='Strategy'
            validateStatus={errors.strategy ? 'error' : null}
            help={errors.strategy}
          >
            <Input
              name='strategy'
              value={data.strategy}
              onChange={this.handleChange}
              size='large'
            />
          </Form.Item>
        </Form>
      </Modal>
    )
  }
}

export default Save
